import { Component, OnInit } from '@angular/core';
import { AccountService, Principal } from '../../../../services';
import { Account, Password, User } from '../../../../models';

@Component({
    selector: 'qms-password-change',
    templateUrl: './password-change.component.html'
})
export class PasswordChangeComponent implements OnInit {
    public passwordMinLength = User.PASSWORD_MIN_LENGTH;
    public passwordMaxLength = User.PASSWORD_MAX_LENGTH; // TODO: move to constants

    public account: Account;
    public password: Password;
    public confirmPassword: string;
    public doNotMatch: boolean;
    public success: boolean;

    constructor(private accountService: AccountService,
                private principal: Principal) {
        this.password = new Password();
        this.doNotMatch = null;
    }

    ngOnInit() {
        this.principal.identity().then((account: Account) => {
            this.account = account;
        });
    }

    public changePassword() {
        this.doNotMatch = null;
        this.success = null;
        if (this.password.newPassword !== this.confirmPassword) {
            this.doNotMatch = true;
        } else {
            this.doNotMatch = false;
            this.accountService.changePassword(this.password).subscribe(() => {
                this.success = true;
            }, () => {
                this.success = false;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/account/password/change/password-change.component.ts